/**
 * Elliott wave (multi-vertex path) interaction, co-located with the tool
 * (Phase 5). Unlike the two-anchor tools, placement is incremental: each click
 * appends a vertex, dblclick/Esc commits, and a vertex drag updates one point —
 * all direct dispatches (appendPathVertex / commitPathDraft / updatePathVertex)
 * with no transformation, so they stay inline in Chart.tsx. The one pure bit is
 * the live preview, here.
 */
import type { Path, PathPoint } from "@/state/slices/uiSlice";

/** Preview polyline: the committed draft vertices plus the cursor as a
 *  trailing point so the next segment tracks the mouse. */
export function pathPreview(draft: PathPoint[], hover: PathPoint | null): Path {
  return {
    id: "preview-path",
    points: hover ? [...draft, hover] : draft,
  };
}
